import { useState } from "react";

const steps = [
  { icon: "ri-focus-3-line", title: "指出人物", desc: "告诉我们主角是谁：明星、网红、主播还是公众人物，尽量给出官方名。" },
  { icon: "ri-calendar-event-line", title: "贴时间", desc: "事件发生在什么时间、哪个平台、有没有原文链接或截图，越具体越好。" },
  { icon: "ri-file-edit-line", title: "等归档", desc: "小编按时间线整理成档案，标注来源档位，核实后再上架对应分区。" },
  { icon: "ri-chat-3-line", title: "回广场对线", desc: "上架后回到人物话题下讨论，大家会一起帮你补遗漏和纠偏。" },
];

const faqs = [
  {
    q: "黑料百科到底是做什么的？",
    a: "88黑料官网不是搬运单个爆料帖，而是把某位明星、网红、主播或公众人物背后的黑料条目，按事件背景、发生时间和关联信息整理成可检索、可对照的百科式档案，方便一次性查清脉络。",
  },
  {
    q: "按名字检索能查到什么？",
    a: "输入人物名字后，页面会集中呈现与 TA 相关的黑料条目，包含已整理的档案、关联人物与后续回应。若某人物尚未建档，会提示你去投稿，尽量不做缺档。",
  },
  {
    q: "每条信息都一定属实吗？",
    a: "不确定。我们在条目上标注「已核实 / 待证实 / 争议中」三档，原始来源与时间尽量写明，供你自己判断。拿不准的一律不按实锤处理。",
  },
  {
    q: "人物可以申请不被收录吗？",
    a: "可以。若你本人或你代表的主体认为档案存在误伤，可通过投稿入口提交异议，我们会复核并标注或下架对应条目。",
  },
  {
    q: "我可以匿名投稿吗？",
    a: "可以。投稿仅用于整理，不会公开你的身份。我们也鼓励提供可核验的公开来源，这样归档更快。",
  },
];

export default function InfoSection() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="info" className="mx-auto w-full max-w-6xl scroll-mt-24 px-4 py-10 md:py-14">
      <div className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
        {/* 投稿指南 */}
        <div>
          <p className="mb-1 flex items-center gap-2 text-xs font-semibold tracking-widest text-primary-500">
            <span className="inline-block h-px w-6 bg-primary-400" />
            SUBMIT
          </p>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            你怎么把一条瓜送进档案库
          </h2>
          <p className="mt-2 max-w-md text-sm leading-6 text-foreground-500">
            一人一档，大家一起补。档案能被建起来，靠的是你们愿意把手上那点信息交出来、慢慢对。
          </p>

          <div className="mt-6 space-y-3">
            {steps.map((s, i) => (
              <div key={s.title} className="flex gap-4 rounded-2xl border border-background-200 bg-background-50 p-4">
                <span className="font-heading flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-800">
                  <i className={`${s.icon} text-lg`} />
                </span>
                <div>
                  <h3 className="text-[15px] font-bold text-foreground-900">
                    <span className="mr-1.5 text-xs font-black text-primary-500">0{i + 1}</span>
                    {s.title}
                  </h3>
                  <p className="mt-1 text-sm leading-6 text-foreground-500">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-5 flex flex-col gap-2 sm:flex-row">
            <button
              type="button"
              className="flex flex-1 items-center justify-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-quill-pen-line" /> 我要投稿
            </button>
            <button
              type="button"
              className="flex flex-1 items-center justify-center gap-1 whitespace-nowrap rounded-full border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <i className="ri-download-2-line" /> 下载 App 追更
            </button>
          </div>
        </div>

        {/* FAQ */}
        <div>
          <p className="mb-1 flex items-center gap-2 text-xs font-semibold tracking-widest text-primary-500">
            <span className="inline-block h-px w-6 bg-primary-400" />
            FAQ
          </p>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            关于 88黑料百科，你可能想问
          </h2>
          <div className="mt-6 space-y-3">
            {faqs.map((f, i) => (
              <div key={f.q} className="overflow-hidden rounded-2xl border border-background-200 bg-background-50">
                <button
                  type="button"
                  onClick={() => setOpen(open === i ? -1 : i)}
                  className="flex w-full items-center justify-between gap-3 px-4 py-3.5 text-left"
                >
                  <h3 className="text-[15px] font-bold text-foreground-900">{f.q}</h3>
                  <i
                    className={`ri-add-line shrink-0 text-lg text-foreground-400 transition-transform ${
                      open === i ? "rotate-45 text-primary-500" : ""
                    }`}
                  />
                </button>
                {open === i && (
                  <p className="px-4 pb-4 text-sm leading-6 text-foreground-500">{f.a}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}